<template>
  <v-list class="pt-0"
          :class="{
            'mt-0': $vuetify.display.smAndDown,
            'px-3': !isMiniAndHomeLayout,
          }"
          :selected="selectedItems"
          @update:selected="updateSelected"
  >
    <div
      v-for="(item, i) in items"
      :key="`item_${i}`"
    >
      <template v-if="item.title === 'separator'">
        <v-divider :key="i" class="my-1 text-grey-100" style="opacity: 1;"></v-divider>
      </template>
      <template v-else>
        <slot name="section" :item="item">
          <component :is="item.customComponent" v-if="item.customComponent"
            :item="item"
          />
          <ProjectNavigationSection 
            v-else
            :action="item.action"
            :data-locator="item.locatorValue"
            :icon-component="item.iconComponent"
            :icon="item.icon"
            :key="item.key"
            :title="item.title"
            :to="item.key"
          />
        </slot>
      </template>
    </div>
  </v-list>
</template>

<script>
import { mapState } from 'vuex';

import ProjectNavigationSection from '@/project/navigation-drawer/ProjectNavigationSection.vue'

  export default {
    name: 'ProjectNavigationDrawerLayout',
    components: { ProjectNavigationSection },
    props: {
      items: {
        type: Array,
        required: true,
      },
      defaultSelectedItem: {
        required: true,
        default: '',
      },
    },
    data () {
      return {
        selectedItems: [],
      }
    },
    watch: {
      defaultSelectedItem: {
        handler (value) {
          this.selectedItems = [value]
        },
        immediate: true,
      },
    },
    computed: {
      ...mapState('global', ['mini', 'homeLayout', 'projectLayout']),
      isMiniAndHomeLayout () {
        return this.mini && this.homeLayout
      },
    },
    methods: {
      updateSelected (value) {
        // If the value is an object, it means that the user clicked on a section already selected
        if (typeof value != 'object') {
          this.selectedItems = value
        }
      },
    },
  }
</script>
